import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <p className="text-sm font-semibold tracking-[0.2em] text-admin-accent">KULUM</p>
          <h1 className="mt-2 text-3xl font-bold text-admin-ink">Admin Console</h1>
          <p className="mt-2 text-sm text-admin-muted">審査・管理用の管理者画面です。</p>
        </div>
        <div className="rounded-3xl border border-admin-border bg-admin-surface p-6 shadow-[0_18px_45px_rgba(15,23,42,0.1)] md:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

